import get from "lodash.get";
import MessageError from "@/helpers/MessageError";

const state = {
};

const getters = {
};

const actions = {
	GetDomainEntityStorageLocationsForBackup({commit}, request_data)
	{
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('entities.get-domain-entity-storage-locations-for-backup', {
				domain_id: request_data['domain_id']
			});

			this._vm.$axios.get(r, request_data)
				.then(response => {
					if (response.data.call_status === "OK")
					{
						resolve(response.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},
};

const mutations = {
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
